// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchCompleteLoadProduct,
    InitVariantProduct,
    LoadProductIfNeeded,
    RequestVariantChildrenFromApi,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";

const XngLoadProductIfNeeded: typeof LoadProductIfNeeded = props => {
    (props.parameter as { additionalExpands?: string[] }).additionalExpands = [
        ...((props.parameter as { additionalExpands?: string[] }).additionalExpands || []),
        "properties",
    ];
};

// XNG-Changes: passing selectedProductId = props.product.id even if it's a perant product. WES-1795

export const XngDispatchCompleteLoadProduct: any = (props: any) => {
    if (!props.product) {
        return;
    }

    props.dispatch({
        type: "Pages/ProductDetails/CompleteLoadProduct",
        productInfosById: props.productInfosById ?? {},
        variantSelection: props.variantSelection ?? {},
        selectedProductId: props.product.id,
        configuration: props.product.detail?.configuration,
    });
};

// Xng-Change: setting product variants in state.
export const XngDispatchCompleteLoadVariants: any = (props: any) => {
    if (!props.product) {
        return;
    }

    props.dispatch({
        type: "xProductDetails/SetParentProduct",
        parentProductVariants: props.variantChildren,
    });
};

// xng-change check if it's parent product first to avoid infinite await loop
export const XngInitVariantProduct: typeof InitVariantProduct = async props => {
    if (props.product?.isVariantParent && !props.parameter.styledOption) {
        return;
    }
    await InitVariantProduct(props);
};

addToChainBefore(chain, LoadProductIfNeeded, XngLoadProductIfNeeded);
replaceInChain(chain, DispatchCompleteLoadProduct, XngDispatchCompleteLoadProduct);
addToChainAfter(chain, RequestVariantChildrenFromApi, XngDispatchCompleteLoadVariants);
replaceInChain(chain, InitVariantProduct, XngInitVariantProduct);
